import { TimeZone } from "types"
import { parseEnumLabel } from "../string"

export const timezoneOptions = Object.keys(TimeZone).map((option) => ({
    label: parseEnumLabel(TimeZone[option]),
    value: TimeZone[option]
}))
